<form class="forms">
  <div class="row">
    <div class="row info-container white-box">
      <h2>Resultados contábeis</h2>

      <div class="content">
        <div class="resultado-card">
          <span class="icon balanco-patrimonial"></span>
          <label>BALANÇO PATRIMONIAL</label>
          <div class="actions">
            <a (click)="abrirModalBalancoPatrimonial()">Ver mais</a>
          </div>
        </div>

        <div class="resultado-card">
          <span class="icon demonstrativo-resultado"></span>
          <label>DEMONSTRATIVO DE RESULTADO (DRE)</label>
          <div class="actions">
            <a (click)="abrirModalDemonstrativoResultado()">Ver mais</a>
          </div>
        </div>

        <div class="resultado-card">
          <span class="icon indicadores"></span>
          <label>INDICADORES (%)</label>
          <div class="actions">
            <a (click)="abrirModalIndicadores()">Ver mais</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>

<app-botao-navegacao
(previous)="onClickPrevious()"
(next)="onClickNext()"
[previousShow]="true"
[nextShow]="true"
[nextEnabled]="true">
</app-botao-navegacao>
